module.exports = __webpack_public_path__ + "static/Calibre-Semibold-347808401d7a6607ff9a86897aec0a39.woff";